var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.78,16.39l4.22,4.22-1.39,1.39-4.22-4.22c-1.57,1.26-3.52,1.94-5.53,1.94-4.89,0-8.86-3.97-8.86-8.86S5.97,2,10.86,2s8.86,3.97,8.86,8.86c0,2.01-.68,3.96-1.94,5.53Zm-1.98-.73c1.25-1.28,1.95-3.01,1.94-4.8,0-3.81-3.08-6.89-6.89-6.89s-6.89,3.08-6.89,6.89,3.08,6.89,6.89,6.89c1.79,0,3.51-.69,4.8-1.94l.15-.15Zm-5.93-5.78v-2.95h1.97v2.95h2.95v1.97h-2.95v2.95h-1.97v-2.95h-2.95v-1.97h2.95Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.e7ee76e51c1956df2fb83784d9bab2dc.svg";
export { ForwardRef as ReactComponent };